import { render } from "./ModalLogs.vue?vue&type=template&id=7edb9ca4"
import script from "./ModalLogs.vue?vue&type=script&lang=js"
export * from "./ModalLogs.vue?vue&type=script&lang=js"

import exportComponent from "D:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__